import { deserialize, serializable } from 'serializr';

export class TrelloIssueTypeModel {
  @serializable
  public close: boolean;
  @serializable
  public idBoard: string;
  @serializable
  public id: string;
  @serializable
  public name: string;
  @serializable
  public status: string | null;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TrelloIssueTypeModel, input));
  }
}
